import { render, staticRenderFns } from "./_TenantsPartages.vue?vue&type=template&id=14d64ba1&"
import script from "./_TenantsPartages.vue?vue&type=script&lang=ts&"
export * from "./_TenantsPartages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports